(function HideImgByOption() {
  const allOptions = document.querySelectorAll('.js-option');
  const allThumbnails = document.querySelectorAll('[data-thumbnails-alt]');

  const updateThumbnails = () => {
    const selectedOption = document.querySelector('.js-option:checked');

    if (selectedOption) {
      const dataOption = selectedOption.value.toUpperCase();
      allThumbnails.forEach(thumb => {
        const dataThumb = thumb.dataset.thumbnailsAlt.toUpperCase();
        const dataThumbSplitted = dataThumb?.split("|");
        if(dataThumbSplitted.length > 1) {
          const dataThumbSecondValue = dataThumbSplitted[1].trim();
          if(dataThumbSecondValue === "INFO") {
            return;
          }
          thumb.setAttribute('data-show', dataThumbSecondValue.includes(dataOption));
        }
      });
    }
  };

  allOptions.forEach(option => {
    updateThumbnails();
    option.addEventListener('click', updateThumbnails);
  });

})();